export const getDentSelector = store => {
    return store.getIn(["dents", "dents"])
}